﻿import { IProject } from "@/interfaces";
import { useIsAdmin, useIsProjectLeader } from ".";

export function useIsProjectLeaderOnly(
  projectLoading: boolean,
  project: IProject
) {
  const isProjectLeader = useIsProjectLeader(projectLoading, project);
  const isAdmin = useIsAdmin();

  return isProjectLeader && !isAdmin;
}
